export { useTranslation, I18nextProvider, Trans } from '@wix/wix-i18n-config';
//# sourceMappingURL=I18nextProvider.js.map